import { Subject } from 'rxjs';
import { DrawableObject } from '../renderer';
import { ObjectManager } from '../object';

export class VisualDebugManager {
  private debugVisualizers: Map<string, VisualDebug[]>;

  public get debugOptions(): string[] {
    return [...this.debugVisualizers.keys()];
  }

  constructor(private objectManager: ObjectManager) {
    this.debugVisualizers = new Map<string, VisualDebug[]>();
  }

  public add(key: string, enable?: boolean): VisualDebug {
    if (!this.debugVisualizers.has(key)) {
      this.debugVisualizers.set(key, []);
    }

    let debug = new VisualDebug(key, this.objectManager);

    this.debugVisualizers.get(key)?.push(debug);

    if (enable) {
      debug.enabled = true;
    }

    return debug;
  }

  public getEnabledState(key: string): boolean {
    if (this.debugVisualizers.has(key)) {
      let enabled = true;
      this.debugVisualizers.get(key)?.forEach((debug) => (enabled = debug.enabled));
      return enabled;
    } else {
      return false;
    }
  }

  public enable(key: string) {
    this.setEnabledState(key, true);
  }

  public disable(key: string) {
    this.setEnabledState(key, false);
  }

  public setEnabledState(key: string, enabled: boolean) {
    if (this.debugVisualizers.has(key)) {
      this.debugVisualizers.get(key)?.forEach((debug) => (debug.enabled = enabled));
    }
  }
}

export class VisualDebug {
  public stateChanged: Subject<VisualDebug>;

  private _objects: DrawableObject[];
  private _enabled: boolean;

  constructor(
    public key: string,
    private objectManager: ObjectManager,
  ) {
    this._objects = [];
    this._enabled = false;

    this.stateChanged = new Subject<VisualDebug>();
  }

  public get objects(): DrawableObject[] {
    return this._objects;
  }

  public set objects(objects: DrawableObject[]) {
    this.removeObjects();
    this._objects = objects;
    if (this.enabled) {
      this.addObjects();
    }
  }

  public get enabled(): boolean {
    return this._enabled;
  }

  public set enabled(val: boolean) {
    this._enabled = val;
    this.stateChanged.next(this);

    if (val) {
      this.addObjects();
    } else {
      this.removeObjects();
    }
  }

  private removeObjects() {
    for (let obj of this._objects) {
      this.objectManager.removeObject(obj);
    }
  }

  private addObjects() {
    for (let obj of this._objects) {
      this.objectManager.addObject(obj);
    }
  }
}
